import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthGuard } from 'src/shared/guards/auth.guard';


const routes: Routes = [
  {
    path: 'auth',
    loadChildren: () => import('../components/auth/auth.module').then(m => m.AuthModule)
  },
  {
    path: 'dashboard',
    loadChildren: () => import('../components/dashboard/dashboard.module').then(m => m.DashboardModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'generalmaster',
    loadChildren: () => import('../components/general-master/general-master.module').then(m => m.GeneralMasterModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'administration',
    loadChildren: () => import('../components/administration/administration.module').then(m => m.AdministrationModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'billing',
    loadChildren: () => import('../components/billing/billing.module').then(m => m.BillingModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'billreport',
    loadChildren: () => import('../components/reports/reports.module').then(m => m.ReportsModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'radiology',
    loadChildren: () => import('../components/services/services.module').then(m => m.ServicesModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'chart',
    loadChildren: () => import('../components/charts/charts.module').then(m => m.ChartsModule),
    canActivate: [AuthGuard]
  },
  {
    path: '**',
    redirectTo: 'dashboard'
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
